import selectors from './selectors';

export const translationSelectors = selectors;
